import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { EmptyResultComponent } from "@shared/components/empty-result/empty-result.component";
import { LocalizedDatePipe } from "@shared/pipes/localized-date.pipe";
import { MoneyFormatPipe } from "@common/pipe/money-format.pipe";
import { NgForOf, NgIf } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { UnitTypeDirective } from '@common/directive/unit-type.directive';

@Component({
  selector: 'app-side-costs-of-contract-details',
  standalone: true,
  imports: [
    EmptyResultComponent,
    LocalizedDatePipe,
    MoneyFormatPipe,
    NgForOf,
    NgIf,
    TranslatePipe,
    UnitTypeDirective
  ],
  templateUrl: './side-costs-of-contract-details.component.html',
  styleUrl: './side-costs-of-contract-details.component.scss'
})
export class SideCostsOfContractDetailsComponent {
  data: InputSignal<any> = input();
  @Output() edit = new EventEmitter();

  onEdit(): void {
    this.edit.emit();
  }
}
